var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Wine_Can",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("path", {
        staticStyle: { fill: "#fff", "stroke-width": "0px" },
        attrs: {
          d: "m35.374,68.567v14.348l3,4.794h23.253l3-4.794v-15.464s0-34.179,0-34.179c0-1.263-.299-2.509-.873-3.634l-1.127-2.21h-25.253l-1.127,2.21c-.574,1.125-.873,2.371-.873,3.634v35.295Z",
        },
      }),
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m62.181,88.708h-24.361l-3.446-5.506v-49.93c0-1.413.34-2.827.981-4.089l1.406-2.756h26.479l1.405,2.756c.643,1.262.982,2.676.982,4.089v49.93l-3.446,5.506Zm-23.254-2h22.146l2.554-4.08v-49.355c0-1.099-.265-2.199-.765-3.181l-.848-1.664h-24.029l-.849,1.664c-.499.981-.764,2.082-.764,3.181v49.355l2.554,4.08Z",
        },
      }),
      _c("polygon", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          points:
            "63.627 27.428 61.627 27.428 61.627 23.87 38.373 23.87 38.373 27.428 36.373 27.428 36.373 21.87 63.627 21.87 63.627 27.428",
        },
      }),
      _c("rect", {
        staticStyle: { "stroke-width": "0px" },
        attrs: { x: "35.373", y: "82.62", width: "29.254", height: "2" },
      }),
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m64.627,23.87h-29.254c-.553,0-1-.447-1-1s.447-1,1-1h29.254c.553,0,1,.447,1,1s-.447,1-1,1Z",
        },
      }),
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m47.711,23.87c-.256,0-.512-.098-.707-.293-.391-.391-.391-1.023,0-1.414l4.578-4.578c.391-.391,1.023-.391,1.414,0s.391,1.023,0,1.414l-4.578,4.578c-.195.195-.451.293-.707.293Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }